// create new Internal Account

import InternalAccountService from "../../services/oldServices/InternalAccountService";

const getDefaultState = () => {
  return {
    test: "",
    moduleLoading: false,
    // moduleLoadingTwo: true,
    moduleLoadingThree: true,
    moduleLoadingFour: true,
    moduleLoadingFive: false,
    createTellerFormBody: {
      source: "web"
    },
    // bankStatData: {},
    internalAccounts: [],
    internalAccountsCheckersQueue: []
  };
};
export const state = getDefaultState();

export const getters = {
  // returns the current user.
  getInternalAccountsNames(state) {
    return state.internalAccounts.map(account => {
      return account.accountName + ` -${account.accountNumber}`;
    });
  }
};

export const mutations = {
  // RESET State
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TEST(state, payload) {
    state.test = payload;
  },
  SET_LOADING(state, status) {
    state.moduleLoading = status;
  },
  // SET_LOADING_TWO(state, status) {
  //     state.moduleLoadingTwo = status;
  // },
  SET_LOADING_THREE(state, status) {
    state.moduleLoadingThree = status;
  },
  SET_LOADING_FOUR(state, status) {
    state.moduleLoadingFour = status;
  },
  SET_LOADING_FIVE(state, status) {
    state.moduleLoadingFive = status;
  },

  SET_ALL_INTERNAL_ACCOUNTS(state, payload) {
    state.internalAccounts = payload;
  },
  SET_ALL_INTERNAL_ACCOUNTS_CHECKERS_QUEUE(state, payload) {
    state.internalAccountsCheckersQueue = payload;
  }
};
export const actions = {
  checkerAuthorizeInternalAccounts({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING_FIVE", true);

    return InternalAccountService.checkerAuthorizeInternalAccounts(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_FIVE", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          // push Notification
          const notification = {
            type: "success",
            message: `Success - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          // push Notification
          const notification = {
            type: "error",
            message: `Error - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        }
        return responseData;
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_FIVE", false);

        throw error;
      });
  },

  allInternalAccountsCheckersQueue({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING_FOUR", true);

    return InternalAccountService.allInternalAccountsCheckersQueue(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_FOUR", false);

        const responseData = response.data;

        if (responseData.responseCode === "00") {
          commit("SET_ALL_INTERNAL_ACCOUNTS_CHECKERS_QUEUE", responseData.data);
        } else {
          // push Notification
          const notification = {
            type: "error",
            message: `Error - Error Loading Table | Try again`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_FOUR", false);

        throw error;
      });
  },

  createInternalAccount({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING", true);

    return InternalAccountService.createInternalAccount(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          // push Notification
          const notification = {
            type: "success",
            variant: "success",
            message: `${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          // push Notification
          const notification = {
            type: "error",
            variant: "danger",
            message: `Error - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING", false);

        throw error;
      });
  },
  // list all tellers
  allInternalAccounts({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING_THREE", true);

    return InternalAccountService.allInternalAccounts(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_THREE", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          commit("SET_ALL_INTERNAL_ACCOUNTS", responseData.data);
        } else {
          // push Notification
          const notification = {
            type: "error",
            variant: "danger",
            message: `Error - Error Loading Table From Me | Try again`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_THREE", false);

        throw error;
      });
  },

  // Reset State
  resetState({ commit }) {
    commit("RESET_STATE");
  }
};
